import React, { Component } from "react";
import CIRVoucherForm from "../CIRVoucherForm/CIRVoucherForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AccountingPage
Description : Componente que contienen el formulario de la pantalla Accounting 
Date Autor Modification
================================================================================
04/11/2021 Cristian Andres Pizo Mina – Se llama al componente AccountingForm
================================================================================ */
class CIRVoucherPage extends Component {
    render() {
        return (
            <div>
                <CIRVoucherForm />
            </div>
        )
    }
}

export default CIRVoucherPage;